import FormStripeView from 'routes/ReferralForm/FormStripeView/FormStripeView';

export default FormStripeView;
